import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Partner } from '../../models/partner';

@Component({
  selector: 'app-partner-edit-popup',
  templateUrl: './partner-edit-popup.component.html',
  styleUrls: ['./partner-edit-popup.component.css']
})
export class PartnerEditPopupComponent {

  partner: Partner;
  title: '';
  confirmButtonEnabled: boolean;
  eventConfirmButton: () => void;

  constructor(
    public dialogRef: MatDialogRef<PartnerEditPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.partner = data.partner;
    this.title = data.title;
    this.eventConfirmButton = data.eventConfirmButton;
  }

  closeClick(): void {
    this.dialogRef.close();
  }

  editDataInvalid(): void {
    this.confirmButtonEnabled = false;
  }

  editDataValid(): void {
    this.confirmButtonEnabled = true;
  }

  confirmClick(): void {
    if (!this.eventConfirmButton) {
      return;
    }
    this.eventConfirmButton();
    this.closeClick();
  }
}
